import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { FormDataById } from 'pages/Forms/types/form';
import { fetchFormDataById, verifyFormLink } from './services';
import { QUERY_KEYS } from './keysAndEndpoints';

export const useVerifyFormLink = (id: string) =>
  useQuery({
    queryKey: [QUERY_KEYS.VERIFY_FORM_LINK, id],
    queryFn: () => verifyFormLink(id),
    enabled: !!id,
    retry: (_, error: AxiosError) => error?.response?.status !== 400,
  });

export const useFetchFormDataById = (id: string) =>
  useQuery<FormDataById>({
    queryKey: [QUERY_KEYS.FETCH_FORM_DATA_BY_ID, id],
    queryFn: () => fetchFormDataById(id),
    enabled: !!id,
    staleTime: 0,
  });
